export default __webpack_public_path__ + "static/media/instagram.ac1a641e.svg";